<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    :style="iconStyles"
  >
    <path
      d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V20C23.5 21.933 21.933 23.5 20 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4C0.5 2.067 2.067 0.5 4 0.5Z"
      :stroke="strokeColor"
    />
    <path
      d="M6 15.3333V16.6667H10V15.3333H6ZM6 7.33333V8.66667H12.6667V7.33333H6ZM12.6667 18V16.6667H18V15.3333H12.6667V14H11.3333V18H12.6667ZM8.66667 10V11.3333H6V12.6667H8.66667V14H10V10H8.66667ZM18 12.6667V11.3333H11.3333V12.6667H18ZM14 10H15.3333V8.66667H18V7.33333H15.3333V6H14V10Z"
      :fill="fillColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'WorkpackageSettingsIcon',

  props: {
    size: {
      type: [String, Number],
      default: 24,
    },
    color: {
      type: String,
      default: '#023B6E',
    },
  },

  computed: {
    iconStyles() {
      return {
        width: typeof this.size === 'number' ? `${this.size}px` : this.size,
        height: typeof this.size === 'number' ? `${this.size}px` : this.size,
      };
    },

    fillColor() {
      return this.color;
    },

    strokeColor() {
      return this.color;
    },
  },
};
</script>
